<template>
  <!-- 发布帖子 -->
  <el-dialog :title="title||$t('发布')" width="879px" top="8vh" :visible.sync="isVisible" @close="closeModal">

    <el-form ref="ruleForm" :rules="rules" :model="form" label-width="auto">
      <el-form-item prop="tcba_link_type" v-if="tcbcd_temp_type==20">
        <el-radio-group v-model="form.tcba_link_type" @change="linkTypeChange">
          <el-radio :label="20">{{ $t('上传文档') }}</el-radio>
          <el-radio :label="10">{{ $t('链接方式') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="red-box" prop="tcba_title">
        <el-input v-model="form.tcba_title" :placeholder="$t('请您在标题中简明提出问题')" name="tp_title"></el-input>
      </el-form-item>

      <el-form-item prop="tcbcd_id">
        <el-cascader v-model="form.tcbcd_id" :placeholder="$t('请选择目录')" name="tcbcd_id"
         :options="data_list" :show-all-levels="false" :props="casprops" @change="dirChange"></el-cascader>
      </el-form-item>

      <el-form-item class="red-box" prop="tcba_link" v-if="tcbcd_temp_type==20 && form.tcba_link_type==10">
        <el-input v-model="form.tcba_link" :placeholder="$t('请输入地址')" name="tp_title"></el-input>
      </el-form-item>

      <template v-if="(tcbcd_temp_type==20 && form.tcba_link_type==20) || tcbcd_temp_type==30">
        <div class="df tjt">
          <div class="df">
            <p>{{ $t("相关推荐设置") }}:</p>
            <span>（{{ $t('最多增加10个相关推荐，可不设置') }}）</span>
          </div>
          <el-button type="primary" icon="el-icon-plus" size="mini" @click="addAL"></el-button>
        </div>
        <div class="df tjb" v-for="(item, index) in form.tcbal_data" :key="index">
          <el-input v-model="item.title" :placeholder="$t('请输入标题')" @input="$forceUpdate()"></el-input>
          <el-input v-model="item.url" :placeholder="$t('请输入地址')" @input="$forceUpdate()"></el-input>
          <el-button type="danger" icon="el-icon-delete" size="mini" round @click="delAL(index)"></el-button>
        </div>
      </template>
      <br>

      <Editor v-model="form.tcba_content" :height="500" :isUseOss="true" v-if="tcbcd_temp_type==40 || form.tcba_link_type==20"/>

      <!-- 上传附件 -->

      <div class="mt-14" v-if="tcbcd_temp_type==40 || (tcbcd_temp_type!=30 && form.tcba_link_type==20) && (form.tcba_temp_type!=30)">
        <Upload v-model="form.tcba_annex" upType="FILEARR"
          :fileLimit="form.tcba_link_type==20?1:9"
          :fileType="[ 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx','pdf','bmp','jpg','jpeg','png','gif','svg','webp','avi', 'mp4', 'mkv', 'mov', 'wmv', 'rmvb', 'flv', 'webm', 'mp3', 'wav', 'aac', 'ogg', 'flac']"
          :isUseOss="true" :key="componentKey" />
      </div>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal" class="btn1">{{ $t('取消') }}</el-button>
      <el-button type="primary" class="btn2" @click="submitPost">{{ $t('发布') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TinyMCEEditor from '../components/Tinymce/index.vue';
import Editor from '../components/Editor/index.vue';
import Upload from "@/components/Upload/index";
import { getMyInfo } from "@api/home";


export default {
  components: {
    TinyMCEEditor, Editor, Upload
  },
  props: {
    title:{
      type:String,
      required:false
    },
    data_list: {
      type: Array, // 指定参数类型
      required: true // 是否为必需参数
    },
    formData: {
      type: Object, // 指定参数类型
      required: false // 是否为必需参数
    },
  },
  data() {
    return {
      casprops:{
        value:"tcbcd_id",
        label:"title",
      },
      isVisible: false,
      form: {
        tcba_title: "",
        tcba_link_type: 20,
        tcba_link: "",
        tcbal_data: [],
        tcbcd_id: "",
        tcba_content: '',
        tcba_annex: '',
      },
      tcbcd_temp_type: 0,
      rules: {
        tcba_title: [
          { required: true, message: this.$t('请填写正确的文章标题'), trigger: 'blur' }
        ],
        tcbcd_id: [
          { required: true, message: this.$t('请选择目录'), trigger: 'change' }
        ],

      },

      componentKey: 1,
    };
  },
  watch: {
    formData:{
      handler(newVal, oldVal) {
        this.form = JSON.parse(JSON.stringify(newVal))
        this.tcbcd_temp_type = newVal.tcba_temp_type
        let link = newVal.link.map(v=>{
          return {
            title: v.tcbal_title,
            url: v.tcbal_url,
          }
        })
        this.form.tcbal_data = JSON.parse(JSON.stringify(link))
      },
      deep: true
    }
  },
  mounted() {
    
  },
  methods: {
    addAL(){
      if(this.form.tcbal_data.length < 10){
        this.form.tcbal_data.push({
          title: '',
          url: '',
        })
        this.$forceUpdate()
      }
    },
    delAL(index){
      this.form.tcbal_data.splice(index, 1);
      this.$forceUpdate()
    },
    linkTypeChange(val){
      if(val==20){
        this.form.tcba_link = ""
      }else{
        this.tcbal_data = []
        this.tcba_annex = ""
        this.tcba_content = ""
      }
    },
    dirChange(val){
      let tcbcd_id = val.length > 0 ? val[val.length-1] : '';
      const findItem=(arr)=>{
        for(let i=0; i<arr.length; i++){
          if(arr[i].tcbcd_id == tcbcd_id){
            return arr[i].tcbcd_temp_type;
          }
          if(arr[i].children && arr[i].children.length > 0){
            const result = findItem(arr[i].children);
            if(result) return result;
          }
        }
        return null;
      }
      let type = findItem(this.data_list);
      this.tcbcd_temp_type = type
      // 清除表单验证提示
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate();
      }
    },
    openModal() {
      this.isVisible = true;
      this.componentKey = 1;
    },
    closeModal() {
      this.isVisible = false;
      this.$refs['ruleForm'].clearValidate();
      this.$refs['ruleForm'].resetFields();

      setTimeout(() => {
        this.componentKey = 2;
        this.tcbcd_temp_type = 0;
        this.form = {
          tcba_title: "",
          tcba_link_type: 20,
          tcba_link: "",
          tcbal_data: [],
          tcbcd_id: "",
          tcba_content: '',
          tcba_annex: '',
        }
      }, 200);

    },
    validOther(){
      if(this.tcbcd_temp_type==20){
        if(this.form.tcba_link_type==20){
          if(!this.form.tcba_annex){
            this.$message.error(this.$t('请上传附件'));
            return false
          }
        }else{
          if(!this.form.tcba_link){
            this.$message.error(this.$t('请输入地址'));
            return false
          }
        }
      }
      if(this.tcbcd_temp_type==40){
          // if(!this.form.tcba_annex){
          //   this.$message.error(this.$t('请上传附件'));
          //   return false
          // }

      }
      return true
    },
    submitPost() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 检查是否满足提交条件
          if (this.form.tcba_content.trim() || this.form.tcba_link_type == 10 || this.tcbcd_temp_type == 20) {
            // 当类型为10/30/40时，必须检查富文本内容
            if ([10, 30, 40].includes(this.tcbcd_temp_type)) {
              if (!this.form.tcba_content.trim()) {
                this.$message.error(this.$t('请填写正确的文章内容'));
                return;
              }
            }
            if(!this.validOther())return
            let dir = this.form.tcbcd_id;
            const form = JSON.parse(JSON.stringify(this.form))
            if(typeof dir == 'object'){
              form.tcbcd_id = dir.length > 0 ? dir[dir.length-1] : '';
            }

            this.$emit('post-submitted', form);
            setTimeout(() => {
              this.closeModal();
            }, 20);
          } else {
            this.$message.error(this.$t('请填写正确的文章内容'));
          }
        } else {
          const firstErrorField = this.$refs.ruleForm.fields.find(field => field.validateState === 'error');
          const errorElement = document.getElementsByName(firstErrorField.prop)[0];
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }



      })


    }
  }
};
</script>

<style scoped lang="scss">
.languige-text {
  font-size: 14px;
  font-weight: 400;
  color: rgb(25, 25, 25);
  line-height: 24px;
  margin-top: 4px;

  ::v-deep() {
    .el-checkbox__label {
      font-family: "harmonyos";
      color: #191919;
    }
  }
}
.tjt{
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  p{
    color: #333;
  }
  span{
    color: #999;
  }
}
.tjb{
  margin-bottom: 16px;
  align-items: center;
  :deep .el-input{
    margin-right: 20px;
    .el-input__inner{
      height: 42px;
      border: 1px solid #eee;
    }
  }
  .el-button{
    height: 32px;
  }
}

::v-deep() {
  .el-cascader{
    width: 100%;
  }
  .el-select {
    width: 100%;
  }

  .el-form-item__label:before {
    color: transparent !important;
  }

  .el-input__inner {
    height: 52px;
    padding-left: 23px;
    border: none;
    font-size: 14px;
    background-color: transparent;
    color: #949494;

    &::placeholder {
      color: #949494;
    }
  }

  .el-form-item__label {
    padding: 0 18px 0 0;
    position: relative;

    &::after {
      content: "";
      display: block;
      height: 14px;
      width: 1px;
      background-color: #CEC7C6;
      position: absolute;
      right: 0;
      top: 20px;
    }
  }

  .el-form-item__label-wrap .el-form-item__label {
    line-height: 52px;
    color: #423735;
    font-size: 14px;
  }

  .el-form-item {
    height: 54px;
    background-color: #F8F8F8;
    padding: 1px 22px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-radius: 5px;
    border: 1px solid #F2F1F1;
  }

  .el-form-item.red-box {
    background-color: #FDF3F2;
  }

  .el-dialog__headerbtn {
    display: none;

  }

  .el-dialog__header {
    padding: 28px 32px 0px;
  }

  .el-dialog {

    max-height: 82vh;
    border-radius: 12px;
    // transform: translateY(-50%);
    // top: 50%;
  }

  .mce-flow-layout {
    background-color: #FDF3F2;
  }

  .mce-panel {
    border: 0 solid #e2e1e1;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: none;
  }

  .mce-btn {
    background-color: transparent;
  }

  .el-dialog__body {
    margin-top: 20px;
    width: calc(100% - 24px);
    padding: 0px 12px 0 36px;
    max-height: calc(82vh - 180px);
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #CF4325;
      border-radius: 8px;
    }
  }

  .el-dialog__footer {
    padding: 26px 36px 26px;
  }

  .dialog-footer {

    .btn1,
    .btn2 {
      min-width: 76px;
      height: 36px;
      border-radius: 30px;
      padding: 0 16px;
      font-size: 14px;
    }

    .btn1 {
      background-color: #ffffff;
      border: 1px solid #ededed;

      &:hover {
        border: 1px solid #d9462f;
      }
    }

    .btn2 {
      // background-color: #D64F31;
      background: linear-gradient(to right, #eb6f54, #d9462f);
      border: none;

      &:hover {
        background: linear-gradient(to right, #d9462f, #d9462f);
      }
    }
  }

  .el-button+.el-button {
    margin-left: 24px;
  }
}
</style>